import { useEffect } from 'react';
import { useTracking } from 'react-tracking';
import { validate as uuidValidate } from 'uuid';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';
import { useCompanyNotes } from '@/components/Note/hooks/useCompanyNotes';
import { useCompanyNoteModal } from '@/components/Note/components/CompanyNoteModalContext';
interface Props {
  companyId: string;
  uniqueSymbol: string;
}

const isValidNoteParam = (note: string | undefined | null) =>
  note === 'create' || (typeof note === 'string' && uuidValidate(note));

const parseModeQueryParam = (mode: string | null): 'compact' | 'full' => {
  if (mode === 'compact' || mode === 'full') {
    return mode;
  }
  return 'compact';
};

function handleNoteQueryParam(
  noteQueryParam: string | null
): string | undefined {
  if (!isValidNoteParam(noteQueryParam)) {
    return undefined;
  }

  if (noteQueryParam === null) {
    return undefined;
  }

  return noteQueryParam;
}

export const AutoCompanyNoteModal = ({ companyId, uniqueSymbol }: Props) => {
  const { data: notes } = useCompanyNotes(companyId);
  const { openNoteModal } = useCompanyNoteModal();
  const { getItem, removeItem, setItem } = useQueryStringParam();
  const { Track } = useTracking({
    type: 'track',
    subject: 'AutoCompanyNoteModal',
    companyId,
    uniqueSymbol,
  });

  const noteQueryParam = getItem('note');
  const modeQueryParam = getItem('mode');
  const note = handleNoteQueryParam(noteQueryParam);

  useEffect(() => {
    if (!isValidNoteParam(note)) {
      removeItem('note');
      removeItem('mode');
      return;
    }
    setItem('mode', parseModeQueryParam(modeQueryParam));

    if (note === 'create') {
      openNoteModal({ companyId, uniqueSymbol });
      return;
    }
    const foundNote = notes?.find((n) => n.id === note);
    if (foundNote) {
      openNoteModal({ note: foundNote, companyId, uniqueSymbol });
    }
  }, [note, notes]);

  if (isValidNoteParam(note)) {
    return <Track />;
  }
  return null;
};
